import { vars } from "plos/src/styles/theme.css";
import { useTranslation } from "react-i18next";
import { resultStyles } from "./result.css";

interface ResultProps {
  resultChar: string;
}

const Result = ({ resultChar }: ResultProps) => {
  const { t } = useTranslation();
  const resultDict = {
    w: t("result.win", "Win"),
    d: t("result.draw", "Draw"),
    l: t("result.loss", "Loss"),
  };
  const result = resultChar.toLowerCase() as keyof typeof vars.colors.result;

  return (
    <span
      aria-label={
        t("result.label", "Match result: {{result}}", {
          result: resultDict[result],
        }) as string
      }
      className={resultStyles[result]}
    >
      {resultChar}
    </span>
  );
};

export default Result;
